/*
 * Wizard modules action types
 */

let numberOfItems = 1;

export const CREATE_MODULE = 'CREATE_MODULE';
export const TOGGLE_MODULE = 'TOGGLE_MODULE';
export const SET_NUMBER_OF_ITEMS = 'SET_NUMBER_OF_ITEMS';
export const INCREASE_NUMBER_OF_ITEMS = 'INCREASE_NUMBER_OF_ITEMS';

export const createModule = (internalId, id, moduleType, name, label, labelType, amount, unit, description, readMoreLink, bundlePrice, nonBundlePrice, bundleQuantity, _numberOfItems, hideNonBundlePrice, builtInPackage, billingUnit, billingUnitPlural, active) => ({
    internalId,
    type: CREATE_MODULE,
    id,
    moduleType,
    name,
    label,
    labelType,
    amount,
    unit,
    description,
    readMoreLink,
    bundlePrice,
    nonBundlePrice,
    bundleQuantity,
    numberOfItems: (numberOfItems = _numberOfItems),
    hideNonBundlePrice,
    builtInPackage,
    billingUnit,
    billingUnitPlural,
    active,
});

export const toggleModule = (moduleType, active) => ({
    type: TOGGLE_MODULE,
    moduleType,
    active,
});

export const setnumberOfItems = (moduleType, _numberOfItems) => ({
    type: SET_NUMBER_OF_ITEMS,
    moduleType,
    numberOfItems: (numberOfItems = _numberOfItems),
});

export const increaseNumberOfItems = (moduleType) => ({
    type: INCREASE_NUMBER_OF_ITEMS,
    moduleType,
    numberOfUsers: numberOfItems+=1,
});

export const decreaseNumberOfItems = (moduleType) => ({
    type: INCREASE_NUMBER_OF_ITEMS,
    moduleType,
    numberOfUsers: numberOfItems-=1,
});
